
import { CssBaseline, ThemeProvider } from '@mui/material';
import { MAIN_THEME } from './main/style/theme';
import { Rest } from './main/common/rest';
import { Router } from './main/pages/Router';
import { PageRouter } from './main/common/pages';
import { UserManaged, UserSession } from './main/components/user';
import { CMainLoading } from './main/components/cr.ui.slide';
import { Notify } from './main/common/ui.notify';
import { CPAgeRouter } from './main/components/cr.pages';

function App() {
  var host = window.location.hostname;
  var port = window.location.port;

  return (
    <ThemeProvider theme={MAIN_THEME}>
      <CssBaseline enableColorScheme />
      <UserSession>
        <Notify>
          <Rest port={port} host={host}>
            <UserManaged alt={<CMainLoading />}>
              <CPAgeRouter>
                <Router />
              </CPAgeRouter>
            </UserManaged>
          </Rest>
        </Notify>
      </UserSession>
    </ThemeProvider>
  );
}

export default App;
